module.exports = "/_next/static/images/197a1da1c58853aff2f2fb4302e367f8-clips@mobile320.jpg.webp";